
export interface Currency {
  code: string;
  symbol: string;
  name: string;
  rate: number; // Against USD
  locale: string;
}

export const SUPPORTED_CURRENCIES: Currency[] = [
  { code: 'USD', symbol: '$', name: 'US Dollar', rate: 1, locale: 'en-US' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', rate: 83.5, locale: 'en-IN' },
  { code: 'EUR', symbol: '€', name: 'Euro', rate: 0.92, locale: 'de-DE' },
  { code: 'GBP', symbol: '£', name: 'British Pound', rate: 0.78, locale: 'en-GB' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', rate: 158.2, locale: 'ja-JP' },
];

export const formatPrice = (amount: number, currency: Currency) => {
  return new Intl.NumberFormat(currency.locale, {
    style: 'currency',
    currency: currency.code,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount * currency.rate);
};
